












































import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  computed,
} from '@vue/composition-api';
import { useRouter } from 'vivat';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import gql from 'graphql-tag';

import { client, onLogin } from '@/useApollo';
import getCompany from '@/gql/company/getCompany.gql';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const Login = defineComponent({
  setup() {
    const modal = ref(null);

    const loginFormInput = reactive({
      username: '',
      password: '',
    });

    const { route, router } = useRouter();

    const passwordField = ref(null);

    onMounted(() => {
      if (route.value.query.username) {
        const passwordFieldInput = document.querySelector('#common-input-password input[type="password"]');
        if (passwordFieldInput) (passwordFieldInput as HTMLElement).focus();
        loginFormInput.username = route.value.query.username;
      }
    });

    const loginMutation = useMutation(gql`
      mutation login($username: String!, $password: String!) {
        login(username: $username, password: $password) {
          token
          success
          expiresIn
        }
      }
    `, {
      variables: loginFormInput,
    });

    loginMutation.onDone((result) => {
      if ((result as any).data.login.success) {
        onLogin(client, (result as any).data.login.token.split('|')[1]);
        // localStorage.setItem('apollo-token', (result as any).data.login.token);
        if (route.value.query.redirectName) {
          router.push({
            name: route.value.query.redirectName,
            params: { id: route.value.query.id },
          });
        } else {
          router.push({
            name: 'Dashboard',
          });
        }
      } else {
        (modal.value as any).compose({ action: 'ลองใหม่', secondaryAction: 'ติดต่อเจ้าหน้าที่' });
      }
    });
    loginMutation.onError(() => {
      (modal.value as any).compose({ action: 'ลองใหม่', secondaryAction: 'ติดต่อเจ้าหน้าที่' });
    });

    const { result: companyResult } = useQuery(getCompany);
    const company = useResult(companyResult, { logoUrl: '/logo_fast.svg', backgroundUrl: '/img/background/bg-tms.png' }, (data: any) => data.company);

    return {
      company,
      loginMutation,
      passwordField,
      modal,
      loginFormInput,
      buildNote: (window as any).BUILD_NOTE,
    };
  },
  components: {
    CommonModalWithPreset,
  },
});

export default Login;
